import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosResponse } from 'axios'
import { useMemo } from 'react'

export type ProducerResumeData = {
  online_sale: string
  offline_sale: string
  rebate: string
  total_gmv: string
  total_available: string
  total_withdrawals: number | string
  events: EventData[]
}

export interface EventData {
  event_id: number
  event_name: string
  event_date: string
  online_sale: string
  offline_sale: string
  rebate: string
  financial_status: string
  total_gmv: string
  total_available: string
  total_withdrawals: string
  can_withdraw: boolean
}

export interface TrackerResponse {
  resume: ProducerResumeData
  resumeLoading: boolean
  resumeError: string | null
}

export const useGetProducerResume = (
  start: string,
  end: string,
  active: string
): TrackerResponse => {
  const url: string = `producer/analytics/financialResume?start=${end}&end=${start}&active=${active}`
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)
  const nestedData = useMemo(() => data?.data?.data || {}, [data])
  const memoizedValue = useMemo(
    () => ({
      resume: nestedData,
      resumeLoading: isLoading,
      resumeError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}
